/*
---

name: ResolveURL
description: Dynamically resolves the URL.
*/
export function getResolveURL(URL_NAME: string): string {
  let DOMAINRES: string = "";
  const DOMAIN: string = "https://particlemailer.com/";
  //const DOMAINWS = "https://www.particlemailer.com/";
  //const DOMAIN: string = "http://localhost:8080/";
  const URLREADEXT: string = "mcfemail/email/view?";

  // these are the save functions for attachments.
  // Uploadchunks.  worker to upload the file in small chunks.
  if (URL_NAME == "UPLOADCHUNKS") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/chunkedupload";
  }
  // when it's done it calls the merge to put all chuncks together.
  if (URL_NAME == "UPLOADCHUNKSMERGE") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/outlookuploaddz";
  }
  // to remove the attachment
  if (URL_NAME == "URLDELETE") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/outlookdelete";
  }

  // functions to save the MAIN message.
  if (URL_NAME == "URLSAVE") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/outlooksave";
  }

  if (URL_NAME == "URLGETEMAIL") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/getemail";
  }
  if (URL_NAME == "URLSECURITY") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/outlooksecurity";
  }

  if (URL_NAME == "URLTEMPLATE") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OfficeTemplateService/getTemplates";
  }
  if (URL_NAME == "URL_SUBSCRIPTION") {
    DOMAINRES =
      DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OfficeSubscriptionService/getSubscription";
  }

  if (URL_NAME == "URLREAD") {
    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/outlooksecurityread";
  }
  if (URL_NAME == "URLGETIMAGE") {
    DOMAINRES = DOMAIN + "secured2outlook/Images/";
  }
  if (URL_NAME == "URLREADEMAILEXT") {
    DOMAINRES = URLREADEXT;
  }
  if (URL_NAME == "URLREADEMAIL") {
    DOMAINRES = DOMAIN + URLREADEXT;
  }
  if (URL_NAME == "URLREADDOMAIN") {
    DOMAINRES = DOMAIN;
  }
  if (URL_NAME == "DOMAINONLY") {
    DOMAINRES = DOMAIN;
  }

  // need to determine what it does.
  //if (URL_NAME == "URLUPLOAD") {
  //    DOMAINRES = DOMAIN + "BreachBlockerMasterOfficeRest/breachBlockerRest/Secured2OutlookService/uploadMultiple";
  //}

  return DOMAINRES;
}
